import React from 'react';
import './Side.css';
import Poster from './Poster/Poster';
import RecentEventTeaser from './RecentEventTeaser/RecentEventTeaser';
import { environments } from 'environments/environments';
import { RecentEvent } from './RecentEvent.interface';
import Follows from './Follows/Follows';

class Side extends React.Component {
  state = {
    recentEvent: undefined as RecentEvent | undefined,
    display: true
  }

  componentDidMount() {
    this.getRecentEventData()
  }

  getRecentEventData() {
    fetch(environments.serverURL + '/data/recent_event.json?t=' + Date.now())
      .then(async response => {
        const responseEvent: RecentEvent[] = await response.json();
        let recentEvent: RecentEvent | undefined = undefined;
        responseEvent.forEach(event => {
          if (event && !recentEvent) {
            if (event.teaser || event.poster || event.event) {
              if (!event.displayFrom || event.displayFrom < Date.now()) {
                if (!event.displayUntil || event.displayUntil > Date.now()) {
                  recentEvent = event;
                }
              }
            }
          }
        });
        this.setState({ recentEvent: recentEvent });
      })
      .catch(e => console.error('Nejbližší akci se nepovedlo načíst.\n', e));
  }

  toggleDisplay() {
    this.setState({ display: !this.state.display });
  }

  render() {
    const renderSwitchText = this.state.display ? 'Skrýt' : 'Zobrazit';

    return (
      <div className={'side' + (this.state.display ? '' : ' hide')}>
        {this.state.recentEvent
          ? <span className="side-toggler" onClick={() => this.toggleDisplay()}>{renderSwitchText} nejbližší akci</span>
          : null
        }
        <Follows />
        {this.state.recentEvent
          ? <p className="side-teaser-header">Nejbližší akce:</p>
          : null
        }
        <div className="side-teaser">
          {this.state.recentEvent
            ? <RecentEventTeaser teaser={this.state.recentEvent} />
            : null
          }
          {this.state.recentEvent
            ? <Poster image={this.state.recentEvent} />
            : null
          }
          {/* <div className="side-promoted-news">
            Nějaká důležitá novinka a tak..
          </div> */}
        </div>
      </div>
    );
  }
}

export default Side;